/** Wire message type strings (ADR-002 §4–§5). Exported via `@nsftx/...-core/protocol`. */
export const CASHIER_MIRROR_MESSAGE_TYPES = {
  betslipChange: 'betslipChange',
  betslipClear: 'betslipClear',
  checkMirrorStatus: 'checkMirrorStatus',
  announceMirrorReady: 'announceMirrorReady',
  operatorLogin: 'operatorLogin',
  operatorLogout: 'operatorLogout',
  switchGame: 'switchGame',
  settingsUpdate: 'settingsUpdate',
  setPrivateMode: 'setPrivateMode',
  slipCheck: 'slipCheck',
  placingSlip: 'placingSlip',
  placingSlipSuccess: 'placingSlipSuccess',
  placingSlipError: 'placingSlipError',
} as const

export type CashierMirrorMessageType =
  (typeof CASHIER_MIRROR_MESSAGE_TYPES)[keyof typeof CASHIER_MIRROR_MESSAGE_TYPES]
